import { api_serverUrl } from "../../src/apiclients/apiurls.js";
import TabIDConstant from "./TabIDConstant.js";
const SERVER_URL = api_serverUrl;
let token = sessionStorage.getItem("token");

/************************************************************************/
async function connectToAPI(
  tcontextURL,
  tmethod,
  data,
  queuedReq = false,
  contentType = false,
  TabId) {
  console.log("request sub part::::::: " + tcontextURL);
  console.log("url" + SERVER_URL);
  try {
    const response = await fetch(SERVER_URL + tcontextURL, {
      method: tmethod ? tmethod : "GET",
      headers: {
        Authorization: token == null ? sessionStorage.getItem("token") : token,
        ...(contentType != "multipart/form-data" && {
          "Content-Type": "application/json",
        }),
        ...(TabId && { TabId }),
      },
      body: contentType === "multipart/form-data" ? data : JSON.stringify(data),
    });
    if (response.status == 401) {// token got expired.
      return await processRefreshTokenMgmt(tcontextURL, tmethod, data, queuedReq);
    } else if (response.status == 403) {
      redirectToLogin();
    }
    return response;
  } catch (e) {
    console.log("Error :::::::::::::::: " + e);
  }
  return {};
}

function getTabIdFromSession(tabid){
  try {
    let TabId = tabid;
    let mainTabId = sessionStorage.getItem("mainTabId");

    if (mainTabId) {
      TabId = mainTabId;
      sessionStorage.removeItem("mainTabId");
    }  
    return TabId
  } catch (error) {
    
  }
}

let isTokenRefreshing = false;
let refreshQueue = [];

async function processRefreshTokenMgmt(tcontextURL, tmethod, data, queuedReq) {
  try {
    if (!isTokenRefreshing || queuedReq) {
      isTokenRefreshing = true;
      let newRefreshedToken = null;
      try {
        // Fetch a new access token using the refresh token
        newRefreshedToken = await fetchRefreshToken(
          sessionStorage.getItem("refreshtoken")
        );
        if (newRefreshedToken) {
          token = newRefreshedToken; //updating the token varibale with new refreshed token to process without holding in the queue.
          let firstReqRs = await connectToAPI(tcontextURL, tmethod, data);
          return firstReqRs;
        } else {
          return {};
        }
      } catch (error) {
        return {};
      } finally {
        await processQueuedRequests(newRefreshedToken);
      }
    }
    // Queue the current request for retry after the new refresh token is fetched.
    return new Promise((resolve, reject) => {
      refreshQueue.push({ tcontextURL, tmethod, data, resolve, reject });
    });
  } catch (e) {
    return {};
  }
}

async function connectToHeatMapAPI(
  tcontextURL,
  tmethod,
  data,
  queuedReq = false,
  contentType = false,) {
  console.log("request sub part::::::: " + tcontextURL);
  console.log("url" + SERVER_URL);
  try {
    const response = await fetch(SERVER_URL + tcontextURL, {
      method: tmethod ? tmethod : "GET",
      headers: {
        "x-heatmap-token": sessionStorage.getItem("heatmaptoken"),
        ...(contentType != "multipart/form-data" && {
          "Content-Type": "application/json",
        }),
      },
      body: contentType === "multipart/form-data" ? data : JSON.stringify(data),
    });
    if (response.status == 403) {
      redirectToLogin();
    }
    return response;
  } catch (e) {
    console.log("Error :::::::::::::::: " + e);
  }
  return {};
}

async function processQueuedRequests(newRefreshedToken) {
  try {
    while (newRefreshedToken && refreshQueue.length > 0) {
      let { tcontextURL, tmethod, data, resolve } = refreshQueue.shift(); //removes the first element in the array and returns it.
      console.log(`Uerl ${newRefreshedToken}ontext URL ::${tcontextURL}`);
      let apiResponse = await connectToAPI(tcontextURL, tmethod, data, true);
      resolve(apiResponse);
    }
    isTokenRefreshing = false; // Token refreshment is done and disabling the flag to false.
  } catch (refreshError) {
    // Rejecting all the queued requests
    while (refreshQueue.length > 0) {
      const { reject } = refreshQueue.shift();
      reject(refreshError);
    }
  }
}

export async function fetchRefreshToken(refreshToken, count = 1) {
  try {
    sessionStorage.removeItem("token");
    const response = await fetch(SERVER_URL + "api/login/refreshtoken/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: refreshToken
          ? refreshToken
          : sessionStorage.getItem("refreshtoken"),
      },
    });
    if (response.status == 403) {
      redirectToLogin();
      return null;
    } else if (response.status == 500) {
      if (count <= 3) {
        return await fetchRefreshToken(refreshToken, count++);
      }
    }
    if (response.status == 200) {
      let respInfo = await response.json();
      sessionStorage.setItem("token", respInfo.token);
      return respInfo.token;
    }
  } catch (error) {
    return null;
  }
  return null;
}

export function redirectToLogin() {
  sessionStorage.removeItem("refreshtoken");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("loggedUserInfo");
  sessionStorage.removeItem("admin_session");
  window.location.href = "/login";
}

/************************************************************************/

// Sign Out of Application API call.
export async function signOut() {
  try {
    return await connectToAPI(`api/login/signout`);
  } catch (e) { }
}

export async function checkUser(credentials) {
  console.log(credentials);
  console.log(SERVER_URL);

  try {
    const response = await fetch(SERVER_URL + "api/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });
    console.log(response);
    return response;
  } catch (error) {
    return { satus: 500 };
  }
}
export async function loginUser(authkey, dealerId) {


  try {
    const response = await fetch(SERVER_URL + `api/login/gettoken${dealerId ? `?dealerid=${dealerId}` : ""} `, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: authkey
      }
    });
    console.log("Checking login API authkey response");
    console.log(response);

    return response;
  } catch (error) {
    console.error("Unable to validate authkey : " + error);
    return { satus: 500 };
  }
}

export async function getAgents(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/user/${siteId}`, undefined, undefined, false, false, finalTabId);
}
export async function getSpecificUsers(siteId, agentId) {
  return await connectToAPI(`api/user/${siteId}/${agentId}`);
}

export async function getIsFeatureExist(siteId, agentId, fid) {
  return await connectToAPI(`api/user/addon/${siteId}/${agentId}/${fid}`);
}

export async function getIPPhoneDevice(siteId, agentId) {
  return await connectToAPI(`api/user/${siteId}/${agentId}/iphonesinfo`);
}

export async function getUserCallRoute(siteId, agentId) {
  return await connectToAPI(`api/user/${siteId}/${agentId}/callrouting`);
}

export async function getSpacificRoutingInfo(siteId, agentId, dialPlanId) {
  return await connectToAPI(
    `api/user/${siteId}/${agentId}/getSpecific/${dialPlanId}`
  );
}

export async function getLoginToStreams(siteId, agentId) {
  return await connectToAPI(`api/user/${siteId}/${agentId}/streamsLogin`);
}

export async function editRouingUser(updates) {
  return await connectToAPI(`api/user/callrouting`, "PUT", updates);
}

export async function updateRouingUser(updates) {
  return await connectToAPI(`api/user/callrouting`, "POST", updates);
}

export async function deleteRouingPlan(siteId, agentid, dialPlanId) {
  return await connectToAPI(
    `api/user/${siteId}/${agentid}/callrouting/${dialPlanId}`,
    "DELETE"
  );
}

export async function editUserCallRouting(updates) {
  return await connectToAPI(`api/user/editcallrouting`, "PUT", updates);
}

export async function getusergroups(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/usergroups/${siteId}`, undefined, undefined, false, false, finalTabId);
}
export async function getSpecificUserGroup(siteId, groupid) {
  return await connectToAPI(`api/usergroups/${siteId}/${groupid}`);
}

export async function updateGroupUser(updates) {
  return await connectToAPI(`api/usergroups/`, "PUT", updates);
}


export async function addGroupUser(updates) {
  return await connectToAPI(`api/usergroups`, "POST", updates);
}

export async function getUsersOfGroup(siteId, groupid) {
  return await connectToAPI(`api/usergroups/users/${siteId}/${groupid}`);
}

export async function addRemoveUsersFromGroup(updates) {
  return await connectToAPI(`api/usergroups/users`, "PUT", updates);
}

export async function getugroups(siteId) {
  return await connectToAPI(`api/user/groups/${siteId}`);
}

export async function getUsersPartOfGroups(siteId, groupcode, extranCond) {
  return await connectToAPI(`api/user/groups/${siteId}/${groupcode}${extranCond}`);
}

export async function deleteGroupUser(stieId, groupid) {
  return await connectToAPI(`api/usergroups/${stieId}/${groupid}`, "DELETE");
}

export async function getStreamsTeam(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/teams/${siteId} `, undefined, undefined, false, false, finalTabId);
}

export async function CreateStreamsTeam(updates) {
  return await connectToAPI(`api/teams`, "POST", updates);
}
export async function deleteStreamsTeam(stieId, teamid) {
  return await connectToAPI(`api/teams/${stieId}/${teamid}`, "DELETE");
}

export async function getTeamsDetails(siteId, teamid) {
  return await connectToAPI(`api/teams/teamsettings/${siteId}/${teamid}`);
}

export async function UpdateStreamTeam(updates) {
  return await connectToAPI(`api/teams/teamsettings`, "PUT", updates);
}

export async function getUsersAndTeamAdmin(siteId, teamid) {
  return await connectToAPI(`api/teams/teammembers/${siteId}/${teamid}`);
}
export async function updateUsersAndTeamsAdmin(updates) {
  return await connectToAPI(`api/teams/teammembers`, "PUT", updates);
}

export async function getOtherAccountUser(siteId, serchText) {
  return await connectToAPI(`api/teams/get_alternate_account_user/${siteId}/${serchText}`);
}

export async function getMultiSelectFieldDetails(updates, moduleType) {
  if (moduleType === 1) return await connectToAPI(`api/user/multisave`, "POST", updates);
  return await connectToAPI(`api/multisave/optionlist`, "POST", updates);
}
export async function setMultiSelectField(updates, moduleType, confirmFlag) {
  const confirmQuery = confirmFlag ? "?is_confirm=true" : "";
  if (moduleType === 1) return await connectToAPI(`api/user/multisave${confirmQuery}`, "PUT", updates);
  return await connectToAPI(`api/multisave${confirmQuery}`, "PUT", updates);
}

export async function getMisc(siteId, options) {
  console.log("misc " + JSON.stringify(options));
  return await connectToAPI(`api/misc/${siteId}`, "POST", options);
}
export async function createUser(updates) {
  return await connectToAPI(`api/user`, "POST", updates);
}
export async function editUser(updates) {
  return await connectToAPI(`api/user`, "PUT", updates);
}
export async function deleteUserInfo(updates) {
  return await connectToAPI(`api/user/deletereasons`, "POST", updates);
}
export async function deleteUser(updates) {
  return await connectToAPI(`api/user/deleteUsers`, "POST", updates);
}

export async function getSpecificUserStreams(siteId, agentId) {
  return await connectToAPI(`api/user/${siteId}/${agentId}/streams`);
}

export async function editUserStreamsSettings(updates) {
  return await connectToAPI(`api/user/streams`, "PUT", updates);
}
export async function addUserStreamsSpeedDial(updates) {
  return await connectToAPI(`api/user/streams/addSpeeddial`, "PUT", updates);
}

export async function getSMSGroups(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/smsgrp/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function getSpecificSMSGrpDetails(siteid, code) {
  return await connectToAPI(`api/smsgrp/${siteid}/${code}`);
}

export async function updateSMSGroup(updates) {
  return await connectToAPI(`api/smsgrp`, "PUT", updates);
}

export async function createSMSGroup(updates) {
  return await connectToAPI(`api/smsgrp`, "POST", updates);
}

export async function deleteSMSGroup(stieId, grpCode) {
  return await connectToAPI(`api/smsgrp/${stieId}/${grpCode}`, "DELETE");
}

/**
 * Hunt Groups API Calls
 *
 */
export async function getHuntsgroups(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/hunt/${siteId}`, undefined, undefined, false, false, finalTabId);
}
export async function getSpecificHuntGroup(siteId, code) {
  return await connectToAPI(`api/hunt/${siteId}/${code}`);
}
export async function getGroupUsersPhoneNumbers(siteId, code) {
  return await connectToAPI(`api/hunt/${siteId}/${code}/getmembers`);
}
export async function getUserNumberList(siteId, code, seqNo) {
  return await connectToAPI(
    `api/hunt/getAddSeqGrps/${siteId}/${code}/${seqNo}`
  );
}
export async function creatHuntGroup(updates) {
  return await connectToAPI(`api/hunt/`, "POST", updates);
}
export async function editHuntGroup(updates) {
  return await connectToAPI(`api/hunt`, "PUT", updates);
}

export async function editUserExternGroup(updates) {
  return await connectToAPI(`api/hunt/addmembers`, "PUT", updates);
}

export async function deleteHuntGroup(stieId, grpCode) {
  return await connectToAPI(`api/hunt/${stieId}/${grpCode}`, "DELETE");
}

export async function getSupervisorData(siteId, code, flag) {
  return await connectToAPI(`api/hunt/getsupervisors/${siteId}/${code}/${flag} `);
}

export async function externalNumberearch(siteid, phonenumber) {
  return await connectToAPI(`api/phnum/validation/${siteid}/${phonenumber}`);
}

/**
 * ACD Group API Calls
 *
 */

export async function getACDGroups(siteid) {
  return await connectToAPI(`api/acd/${siteid}`);
}

export async function getACDSpecificGroups(siteid, code) {
  return await connectToAPI(`api/acd/${siteid}/${code}`);
}

export async function createACDGroup(updates) {
  return await connectToAPI(`api/acd`, "POST", updates);
}

export async function editACDGroup(updates) {
  return await connectToAPI(`api/acd`, "PUT", updates);
}

export async function deleteACDGroup(siteid, gpcode) {
  return await connectToAPI(`api/acd/${siteid}/${gpcode}`, "DELETE");
}
/**
 * Phone Numbers API Calls
 */

export async function PurchasePHNumber(updates) {
  return await connectToAPI(`api/phnum/purchase`, "POST", updates);
}
export async function deletePHNumber(updates) {
  return await connectToAPI(`api/phnum/delete`, "POST", updates);
}

export async function unassignPHNumber(updates) {
  return await connectToAPI(`api/phnum/unassign`, "PUT", updates);
}

export async function getSpecificPhoneDetails(siteid, number) {
  return await connectToAPI(`api/phnum/${siteid}/${number}`);
}

export async function editPhoneNumberDetails(updates, extraCond) {
  return await connectToAPI(`api/phnum/updatePhoneNumberDtls${extraCond}`, "PUT", updates);
}

export async function getPhoneNumberRemediationData(siteid, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/phnum/phMonitoring/remediation/${siteid}`, undefined, undefined, false, false, finalTabId);
}

export async function getSpecificPhoneRemediation(siteid, phoneNumber) {
  return await connectToAPI(`api/phnum/phMonitoring/remediation/${siteid}/${phoneNumber}`);
}

export async function updatePhoneNumberRemediation(updates) {
  return await connectToAPI(`api/phnum/phMonitoring/remediation`, "POST", updates);
}


/**
 * Phone Provisioning API calls
 *
 * Added By:Ganesh :15-062023
 */
export async function addDevicePhone(siteId, formdata) {
  if (formdata.provisioning == 2) {
    return await connectToAPI(
      `api/phoneProvisiong/${siteId}/manualProvisioning`,
      "POST",
      formdata
    );
  }
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/autoProvisioning`,
    "POST",
    formdata
  );
}
export async function getPhoneDevicesList(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/phoneProvisiong/${siteId}`, undefined, undefined, false, false, finalTabId);
}
export async function getdevicedatainfo(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/getAgentPhoneDesignations`,
    "POST",
    params
  );
}
export async function getUserListInAddDevicepage(siteId) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/getDeviceModelsandAgents`
  );
}
export async function unAssignPhoneDevice(siteId, updates) {
  if (updates.provisioning_method == 2) {
    return await connectToAPI(`api/phoneProvisiong/${siteId}/manualProvisioningDelete`, "POST", updates);
  }
  return await connectToAPI(`api/phoneProvisiong/${siteId}/unAssignDevice`, "POST", updates);
}

export async function deletePhoneDevice(siteId, updates) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/removeUnassignDevice`,
    "POST",
    updates
  );
}

export async function getSpesificManualDeviceDetails(siteId, updates) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/getSpecificManualDevice`,
    "POST",
    updates
  );
}
export async function saveManualDeviceDetails(siteId, updates) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/updateManualSettings`,
    "POST",
    updates
  );
}
export async function passWordReset(siteId, updates) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/manualResetPassword`,
    "POST",
    updates
  );
}

export async function getSpesificAutoDeviceDetails(siteId, updates) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/getSpecificAutoDevice`,
    "POST",
    updates
  );
}

export async function portingSteps(updates) {
  return await connectToAPI(`api/phnum/porting`, "POST", updates);
}
export async function portingStepsForm(updates, tabId = TabIDConstant.TN_TFN_PORT_BTN_SUBLINK) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/phnum/porting`, "POST", updates, false, "multipart/form-data", finalTabId);
}
export async function downloadPortingLOA(updates) {
  return await connectToAPI(`api/phnum/tfnloa`, "POST", updates);
}

export async function uploadCobFile(updates) {
  return await connectToAPI(`api/phnum/cobupload`, "POST", updates, false, "multipart/form-data");
}

/**
 * Auto Attendant API call
 */

export async function getAutoAttendant(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/aagroup/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function getSpecificAAGroup(siteId, code) {
  return await connectToAPI(`api/aagroup/${siteId}/${code}`);
}

export async function creatAAGroup(updates) {
  return await connectToAPI(`api/aagroup`, "POST", updates);
}

export async function updateAAGroup(updates) {
  return await connectToAPI(`api/aagroup`, "PUT", updates);
}

export async function deleteAAGroup(siteId, code) {
  return await connectToAPI(`api/aagroup/${siteId}/${code}`, "DELETE");
}

export async function getAADirectoryAll(siteId, code) {
  return await connectToAPI(`api/aagroup/diruser/${siteId}/${code}`);
}

export async function getAADirectorySpecific(siteId, code, dirid) {
  return await connectToAPI(`api/aagroup/diruser/${siteId}/${code}/${dirid}`);
}
export async function directoryDownload(siteId) {
  return await connectToAPI(`api/global/directoryintegration/download/${siteId}`);
}

/**
 * Paging Groups
 * Added By Ganesh :20092023
 */
export async function getAccountLevelPagingGroupsList(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/getAccountLevelPagingGropupsList`, undefined, undefined, false, false, finalTabId
  );
}
export async function addPagingGroup(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/addPagingGroup`,
    "POST",
    params
  );
}
export async function removePagingGroup(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/deletePagingGroup`,
    "POST",
    params
  );
}
export async function fetchExistingPagingGroups(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/fetchExistingPagingGroupsforAutoDevice`,
    "POST",
    params
  );
}
export async function saveAutoDeviceSettings(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/updateautoSettings`,
    "POST",
    params
  );
}
export async function AddPagingGroupInDeviceSettings(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/AddPagingGroupInAutoDeviceSettings`,
    "POST",
    params
  );
}

/**
 * Roles API calls
 */

export async function getAllRoles(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/roles/${siteId}`, "GET", undefined, false, false, finalTabId);
}

export async function deleteRole(siteId, roleId) {
  return await connectToAPI(`api/roles/${siteId}/${roleId}`, "DELETE");
}

export async function addRole(data) {
  return await connectToAPI(`api/roles/`, "POST", data);
}

export async function getRoleInfo(siteId, roleId) {
  return await connectToAPI(`api/roles/${siteId}/${roleId}`, "GET");
}

export async function updateRole(updates) {
  return await connectToAPI(`api/roles/`, "PUT", updates);
}

/**
 * BLF Groups Creation
 * AddedBy :Ganesh
 */

export async function getAccountLevelBlfGroups(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/getAccountLevelBlfGroupsList`,
    "GET", undefined, false, false, finalTabId
  );
}

export async function addBlfGroup(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/addAccountLevelBlfGroup`,
    "POST",
    params
  );
}

export async function removeBlfGrp(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/deleteAccountLevelBlfGroup`,
    "DELETE",
    params
  );
}

export async function getExistingBlfUSersUnderGroup(siteId, groupid) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/${groupid}/getBlfUsers`,
    "GET"
  );
}
export async function updateBlfGroupName(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/updateGroupNameFromSettings`,
    "put",
    params
  );
}
export async function updatePagingGroup(siteId, params) {
  return await connectToAPI(`api/phoneProvisiong/${siteId}/updatePagingGroupSettings`, "POST", params);
}


export async function removeBlfUser(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/delteBlfUser`,
    "DELETE",
    params
  );
}

export async function confirmDeleteUserinPhones(siteId, params) {
  return await connectToAPI(`api/phoneProvisiong/${siteId}/deleteConfirmReq`, "POST", params);
}

export async function confirmDeleteBlfGroupInPhones(siteId, params) {
  return await connectToAPI(`api/phoneProvisiong/${siteId}/blfGroupDeleteConfirmationReq`, "POST", params);
}

export async function confirmDeletePagingroupInPhones(siteId, params) {
  return await connectToAPI(`api/phoneProvisiong/${siteId}/pagingGroupDeleteConfirmationReq`, "POST", params);
}

export async function getAgentsInAccount(siteId) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/getAgentsInfo`,
    "GET"
  );
}

export async function addNewUsersToBlfGroup(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/addNewUsersToBlfGroup`,
    "POST",
    params
  );
}
export async function editUsersfieldsUnderBlfGroup(siteId, params) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/updateBlfUsers`,
    "PUT",
    params
  );
}

export async function getphoneErrors(siteId, groupid) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/errorCheck/${groupid}`,
    "GET"
  );
}



/**
 * Device MapList
 */

export async function getDeviceMapList(siteId, pbxid) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/getRegisteredDevicesList`
  );
}

export async function getLiveDataRegisteredDevicesInDeviceMap(siteId, agent_id, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(
    `api/phoneProvisiong/${siteId}/fetchRegisteredDevicesWithGeoCoordinates${agent_id ? `?agent_id=${agent_id}` : ''}`,
    undefined, undefined, false, false, finalTabId
  );
}

export async function uploadGreeting(formData) {
  return await connectToAPI(
    `api/media/`,
    "POST",
    formData,
    false,
    "multipart/form-data"
  );
}
export async function uploadEditGreeting(formData) {
  return await connectToAPI(
    `api/media/updategreeting`,
    "POST",
    formData,
    false,
    "multipart/form-data"
  );
}

export async function getGreeting(greetingInfoJson) {
  return await connectToAPI(`api/media/get-media`, "POST", greetingInfoJson);
}

export async function getExistingGreetingsInfo(greetingInfoJson) {
  return await connectToAPI(`api/media/get-all`, "POST", greetingInfoJson);
}

export async function updateExistingGreetings(greetingInfoJson) {
  return await connectToAPI(`api/media/update`, "POST", greetingInfoJson);
}

export async function getAllMediaInfo(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/media/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function deleteMediaFileInfo(greetingInfoJson) {
  return await connectToAPI(`api/media/delete`, "POST", greetingInfoJson);
}

export async function downloadMultiGreeting(greetingInfoJson) {
  return await connectToAPI(`api/media/download_zip`, "POST", greetingInfoJson);
}

export async function deleteMultiMediaFileInfo(greetingInfoJson) {
  return await connectToAPI(`api/media/delete_multiple`, "POST", greetingInfoJson);
}

export async function getGreetingWavFile(greetInfo) {
  return await connectToAPI(`api/media/generate_ttw`, "POST", greetInfo);
}

// Auto Provisioning Buttons

export async function getButtonTypes(siteid) {
  return await connectToAPI(`api/phoneProvisiong/${siteid}/getButtonTypes`);
}

export async function getAccountUsersList(siteid) {
  return await connectToAPI(`api/phoneProvisiong/${siteid}/getAccountUsersList`);
}

export async function saveButtonsData(siteid, buttonsData) {
  return await connectToAPI(`api/phoneProvisiong/${siteid}/persistButtons`, "POST", buttonsData);
}

export async function getLinesInfo(siteid, macInfo) {
  return await connectToAPI(`api/phoneProvisiong/${siteid}/getLinesInfo`, "POST", macInfo);
}

export async function getDeviceOnlineStatusInfo(siteid, pramsJo) {
  return await connectToAPI(`api/phoneProvisiong/${siteid}/fetchDeviceStatus`, "POST", pramsJo);
}
export async function getOnlineDevicesStatusForPhones(siteid, pramsJo) {
  return await connectToAPI(`api/phoneProvisiong/${siteid}/getOnlineDevicesStatusForAllPhones`, "POST", pramsJo);
}
export async function getBlfGroupsInButtonsUI(siteid, macInfo) {
  return await connectToAPI(`api/phoneProvisiong/${siteid}/getBlfGroupsInAutoDevice`, "POST", macInfo);
}

export async function getExistingUserLocations(siteId) {
  return await connectToAPI(`api/locations/${siteId}`);
}

export async function getExisting911Locations(siteId) {
  return await connectToAPI(`api/911/${siteId}`);
}
export async function getExistingOnly911Locations(siteId) {
  return await connectToAPI(`api/phoneProvisiong/${siteId}/get911Locations`);
}

export async function getAllTheLocationsInfo(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/locations/getalllocations/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function removeUserLocation(siteId, location_id, extraParam) {
  return await connectToAPI(`api/locations/${siteId}/${location_id}${extraParam}`, "DELETE");
}

export async function removeUser911Location(siteId, location_id, extraParam) {
  return await connectToAPI(`api/911/${siteId}/${location_id}${extraParam}`, 'DELETE');
}

export async function addLocation(params, country) {
  if (country) return await connectToAPI(`api/locations?country=${country}`, "POST", params);
  return await connectToAPI(`api/locations/`, "POST", params);
}
export async function getAddLocationMisc(params, siteId) {
  return await connectToAPI(`api/misc/${siteId}`, "POST", params);
}
export async function getSpecificLocationData(siteId, locationId) {
  return await connectToAPI(`api/locations/${siteId}/${locationId}`, "GET");
}
export async function get911SpecificLocationData(siteId, locationId) {
  return await connectToAPI(`api/911/${siteId}/${locationId}`);
}
export async function updateNineOOLocations(updates) {
  return await connectToAPI(`api/911`, "PUT", updates);
}

export async function LocAddressSeach(updates) {
  return await connectToAPI(`api/locations/search_loc`, "POST", updates);
}

export async function addToLocation(updates) {
  return await connectToAPI(`api/locations/add_holidays`, "POST", updates);
}

export async function updateLocation(updates, country) {
  if (country) return await connectToAPI(`api/locations?country=${country}`, "PUT", updates);
  return await connectToAPI(`api/locations`, "PUT", updates);
}

export async function getLocations(siteId) {
  return await connectToAPI(`api/locations/${siteId}`);
}

export async function getLocUsers(siteId, locid, extraconditions) {
  return await connectToAPI(`api/locations/${siteId}/${locid}/users${extraconditions}`);

}

export async function moveUsersLoc(updates) {
  return await connectToAPI(`api/locations/move_users`, "PUT", updates);
}

// Add 911 Location

export async function add911Location(updates) {
  return await connectToAPI(`api/911`, "POST", updates);
}

export async function getCallFlows(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/call_flows/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function getSpecificCallFlows(siteId, code) {
  return await connectToAPI(`api/call_flows/${siteId}/${code}`);
}

export async function creatCallFlows(updates) {
  return await connectToAPI(`api/call_flows`, "POST", updates);
}

export async function updateCallFlows(updates) {
  return await connectToAPI(`api/call_flows`, "PUT", updates);
}

export async function createCallFlowsSchedule(updates) {
  return await connectToAPI(`api/call_flows/schedule`, "POST", updates);
}

export async function saveCallFlowsSchedule(updates) {
  return await connectToAPI(`api/call_flows/schedule`, "PUT", updates);
}
export async function deleteCallFlows(siteId, code) {
  return await connectToAPI(`api/call_flows/${siteId}/${code}`, "DELETE");
}

export async function callflowFeedback(siteId, params) {
  return await connectToAPI(`api/call_flows/feedback/${siteId}`, "POST", params);
}

// Spam and call blocking settings

export async function getAllCallBlockList(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/callblocking/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function editCallBlocking(updates) {
  return await connectToAPI(`api/callblocking`, "PUT", updates);
}

export async function creatCallBlocking(updates) {
  return await connectToAPI(`api/callblocking`, "POST", updates);
}

export async function deleteCallBlocking(siteid, uniqueId) {
  return await connectToAPI(`api/callblocking/${siteid}/${uniqueId}`, "DELETE");
}
export async function getBlfConfiguredDevices(params, siteid) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteid}/getBlfConfiguredDevices`,
    "POST",
    params
  );
}

export async function createSchedule(updates) {
  return await connectToAPI(`api/schedules`, "POST", updates);
}

// Global Locations

// get global location for account login
export async function getGlobalLocationForAccount(siteId) {
  return await connectToAPI(`api/global/getlocfilters/${siteId}`);
}

// get global location for user login
export async function getGlobalLocationList(siteId, condn) {
  return await connectToAPI(`api/filters/${siteId}${condn}`);
}

export async function setGlobalLocationFilter(updates) {
  return await connectToAPI(`api/filters`, "PUT", updates);
}

//purchase Phone number
export async function getPurchasePhoneNumbers(updates) {
  return await connectToAPI(`api/phnum/getFreePhoneNumbers`, "POST", updates);
}

//purchase Phone number
export async function sendSMSEnableAPIRequest(jsonBody) {
  return await connectToAPI(`api/phnum/enablesms`, "POST", jsonBody);
}

export async function sendPurchaseSMSPHnumreq(jsonBody) {
  return await connectToAPI(`api/phnum/sendreqforphonenumbers`, "POST", jsonBody);
}

export async function getPhoneNumsByType(phNumType, siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/phnum/getallphonenumbers/${phNumType}/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function getPortingStatusDetails(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/phnum/porting/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function deletePortingDetails(siteId, orderId) {
  return await connectToAPI(`api/phnum/porting/${siteId}/${orderId}`, "DELETE");
}

export async function getPortingDetails(siteId, orderId) {
  return await connectToAPI(`api/phnum/porting/${siteId}/${orderId}`);
}

export async function updateValidatedPhNumDtls(Jsonbody) {
  return await connectToAPI(`api/phnum/updatePhoneNumberDtls`, "PUT", Jsonbody);
}

export async function getPortingFiles(siteId, orderId, downloadType) {
  return await connectToAPI(`api/phnum/get-tn-media/${siteId}/${orderId}/${downloadType}`);
}

/**
 *
 * @param {*} siteId
 * @returns
 */
export async function getSchedulesForCallFlow(siteId, cfId) {
  return await connectToAPI(`api/call_flows/schedules/${siteId}/${cfId}`);
}

export async function getSpecifSchedulesForCallFlow(siteId, schId) {
  return await connectToAPI(`api/call_flows/schedule/${siteId}/${schId}`);
}

export async function getPagingGroupConfiuredDevices(siteID, groupId) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteID}/${groupId}/pagingGroupConfiguredDevices`,
    "GET"
  );
}

//account storage manager

export async function getAccountStorage(siteid, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/storageAddon/${siteid}`, undefined, undefined, false, false, finalTabId);
}

export async function updateStorageAutoPurchase(updates) {
  return await connectToAPI(
    `api/storageAddon/addonAutoPurchase`,
    "PUT",
    updates
  );
}

export async function purchaseStorage(updates) {
  return await connectToAPI(
    `api/storageAddon/purchaseStorage`,
    "POST",
    updates
  );
}
export async function deleteStorage(updates) {
  return await connectToAPI(
    `api/storageAddon/deleteStorage`,
    "DELETE",
    updates
  );
}

//Ucc settings
export async function getUCCSettings(siteid) {
  return await connectToAPI(`api/global/uccSettings/${siteid}`);
}

export async function updateGlobalSettings(updates) {
  return await connectToAPI(`api/global`, "PUT", updates);
}

export async function getSmartBoxSettings(siteid) {
  return await connectToAPI(`api/global/smartboxSettings/${siteid}`);
}

export async function getstreamTeam(siteid) {
  return await connectToAPI(`api/global/publicteams/${siteid}`);
}
export async function getStreamsNotification(siteid) {
  return await connectToAPI(`api/global/streamsnotifications/${siteid}`);
}

export async function getVoicemailOperator(siteid) {
  return await connectToAPI(`api/global/vm/${siteid}`);
}

export async function getActiveDirectory(siteid) {
  return await connectToAPI(`api/global/directoryintegration/${siteid}`);
}

export async function deletDirectoryFailureUser(updates) {
  return await connectToAPI(`api/global/deleteoktafail`, "POST", updates);
}

export async function getSecurityInfo(siteid, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/global/security/${siteid}`, undefined, undefined, false, false, finalTabId);
}

export async function getLoginDetails(siteid) {
  return await connectToAPI(`api/global/${siteid}/logins`);
}

export async function getAllGroupFax(siteid, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/fax/${siteid}`, undefined, undefined, false, false, finalTabId);
}

export async function getSpecificFaxGroupsDetails(siteid, code) {
  return await connectToAPI(`api/fax/${siteid}/${code}`);
}

export async function createFaxGroup(updates) {
  return await connectToAPI(`api/fax`, "POST", updates);
}

export async function updateFaxGroup(updates) {
  return await connectToAPI(`api/fax`, "PUT", updates);
}

export async function deleteFaxGroup(stieId, grpCode) {
  return await connectToAPI(`api/fax/${stieId}/${grpCode}`, "DELETE");
}

export async function sendANewFax(updates) {
  return await connectToAPI(`api/user/fax/send`, "POST", updates, false, "multipart/form-data");
}

export async function forwardNewFax(updates) {
  return await connectToAPI(`api/user/fax/forward/send`, "POST", updates, false, "multipart/form-data");
}


export async function receivedFaxDetails(siteid, agentid) {
  return await connectToAPI(`api/user/fax/receive/${siteid}/${agentid}`);
}

export async function receivedGroupFaxDetails(siteid, groupcode) {
  return await connectToAPI(`api/fax/receive/${siteid}/${groupcode}`);
}

export async function sentFaxDetails(siteid, agentid) {
  return await connectToAPI(`api/user/fax/sent/${siteid}/${agentid}`);
}
export async function sentGroupFaxDetails(siteid, groupcode) {
  return await connectToAPI(`api/fax/sent/${siteid}/${groupcode}`);
}

export async function getForwardFaxInfo(siteid, id) {
  return await connectToAPI(`api/user/fax/${siteid}/${id}`);
}
export async function getForwardGroupFaxInfo(siteid, id) {
  return await connectToAPI(`api/fax/${siteid}/${id}/1`);
}

export async function sendANewGroupFax(updates) {
  return await connectToAPI(`api/fax/send`, "POST", updates, false, "multipart/form-data");
}

export async function forwardANewGroupFax(updates) {
  return await connectToAPI(`api/fax/forward/send`, "POST", updates, false, "multipart/form-data");
}

export async function resendUserFax(siteid, faxid) {
  return await connectToAPI(`api/user/fax/resend/${siteid}/${faxid}`);
}
export async function resendGroupFax(siteid, faxid, groupFaxFlag) {
  return await connectToAPI(`api/fax/resend/${siteid}/${faxid}/${groupFaxFlag}`);
}

export async function downloadFaxFile(siteid, fixid) {
  return await connectToAPI(`api/user/fax/getfaxfile/${siteid}/${fixid}`);
}
export async function downloadGroupFaxFile(siteid, fixid) {
  return await connectToAPI(`api/fax/getfaxfile/${siteid}/${fixid}`);
}

export async function deleteSndRecFax(stieId, grpCode) {
  return await connectToAPI(`api/user/fax/delete/${stieId}/${grpCode}`, "DELETE");
}
export async function deleteSndRecGroupFax(stieId, grpCode, groupFaxFlag) {
  return await connectToAPI(`api/fax/delete/${stieId}/${grpCode}/${groupFaxFlag}`, "DELETE");
}

export async function getStreamSettingsDetails(siteid, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/global/streamssettings/${siteid}`, undefined, undefined, false, false, finalTabId);
}

// User Integration settings
export async function getIntegrationDetail(siteId, agentId) {
  return await connectToAPI(`api/user/integrations/${siteId}/${agentId}`);
}

export async function editIntegrations(updates) {
  return await connectToAPI(`api/user/integrations`, "PUT", updates);
}

export async function deleteWIEvent(siteid, agentid, eventtype) {
  return await connectToAPI(`api/user/integrations/${siteid}/${agentid}/${eventtype}`, "DELETE");
}

export async function getZenDeskUrl() {
  return await connectToAPI(`api/user/download/streamzendesk/`);
}

export async function getCompanyDetailInfo(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/global/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function updateCompanyInfo(updates) {
  return await connectToAPI(`api/global/`, "PUT", updates);
}

export async function getCorporateContact(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/contacts/ViewCorporateContacts/${siteId}`, undefined, undefined, false, false, finalTabId);
}
export async function getAccountContact(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/contacts/getAllContacts/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function getcustomContactFields(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/contacts/getAllCustomFields/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function createAccContacts(updates) {
  return await connectToAPI(`api/contacts/createcontact`, "POST", updates);
}
export async function updateAccContacts(updates) {
  return await connectToAPI(`api/contacts/updatecontact`, "PUT", updates);
}

export async function deleteAccContacts(updates) {
  return await connectToAPI(`api/contacts/deletecontact`, "PUT", updates);
}

export async function getSpecificContactsDetails(siteId, id) {
  return await connectToAPI(`api/contacts/getSpecificContacts/${siteId}/${id}`);
}

export async function createCustomFieldCont(updates) {
  return await connectToAPI(`api/contacts/customField`, "POST", updates);
}
export async function updateCustomFieldCont(updates) {
  return await connectToAPI(`api/contacts/customField`, "PUT", updates);
}

export async function deleteCustomField(siteid, fieldid) {
  return await connectToAPI(`api/contacts/customField/${siteid}/${fieldid}`, "DELETE");
}

export async function downloadContacts(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/contacts/${siteId}/downloadContacts`, undefined, undefined, false, false, finalTabId);
}


export async function createBrand(updates) {
  return await connectToAPI(`api/sms/brand`, "POST", updates);
}
export async function registerTheBrand(updates) {
  return await connectToAPI(`api/sms/brand/register`, "POST", updates);
}
export async function getSMSBrand(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/sms/brand/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function getSpecificSMSBrandDetails(siteid, brandid) {
  return await connectToAPI(`api/sms/brand/${siteid}/${brandid}`);
}

export async function downloadBrandProofDoc(siteid, brandid, fileid, flag) {
  const flagPart = flag !== undefined ? `/${flag}` : "/0";
  return await connectToAPI(`api/sms/get-brand-pdf/${siteid}/${brandid}/${fileid}${flagPart}`);
}

export async function updateSMSBrand(updates) {
  return await connectToAPI(`api/sms/brand`, "PUT", updates, false, "multipart/form-data");
}

export async function deleteSMSBrand(stieId, brandid, flag) {
    return await connectToAPI(`api/sms/brand/${stieId}/${brandid}/${flag}`, "DELETE");
}

export async function getSMSCampaign(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/sms/get-campaigns/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function getSpecificSMSCampDetails(siteid, campid) {
  return await connectToAPI(`api/sms/get-campaigns/${siteid}/${campid}`);
}

export async function createSMSCampaign(updates) {
  return await connectToAPI(`api/sms/campaign`, "POST", updates);
}

export async function deleteSMSCampaigns(stieId, campUniqid) {
  return await connectToAPI(`api/sms/campaign/${stieId}/${campUniqid}`, "DELETE");
}

export async function deleteSMSDraft(stieId, id) {
  return await connectToAPI(`api/sms/deldraft/${stieId}/${id}`, "DELETE");
}

export async function updateSMSCampaigns(updates) {
  return await connectToAPI(`api/sms/campaign-update`, "PUT", updates);
}

export async function updateCampaignProofOfDoc(updates) {
  return await connectToAPI(`api/sms/campaign-pdf`, "PUT", updates, false, "multipart/form-data");
}

export async function removeRejectedNumber(updates) {
  return await connectToAPI(`api/sms/remove-reject`, "PUT", updates);
}

export async function createSMSBrandCampaign(updates) {
  return await connectToAPI(`api/sms/createsmscampaign`, "POST", updates);
}
export async function draftSMSBrandCampaign(updates) {
  return await connectToAPI(`api/sms/draft_save`, "POST", updates);
}

export async function getSMSCampaignDraft(siteId) {
  return await connectToAPI(`api/sms/alldraft/${siteId}`);
}

export async function handleOpenDraft(siteid, drafid) {
  return await connectToAPI(`api/sms/draft/${siteid}/${drafid}`);
}


export async function getBranchnodes(siteid, updates) {
  return await connectToAPI(`api/call_flows/branching`, "POST", updates);
}

export async function updateDefaultMOH(updates) {
  return await connectToAPI(`api/media/defaultmoh`, "PUT", updates);

}

export async function getSMSAttributes(updates) {
  return await connectToAPI(`api/sms/ai-attribute-chk`, "POST", updates);
}


// Org Groups.

// Get all organizations.
export async function getOrganizationsData(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/orggroups/orgs/${siteId}`, undefined, undefined, false, false, finalTabId);
}

// Add Organization.
export async function addOrganization(siteId, orgName) {
  return await connectToAPI(`api/orggroups/orgs`, "POST", { org_name: orgName, siteid: siteId, reqid: 102 });
}

// Delete Organization.
export async function deleteOrganization(siteId, orgId) {
  return await connectToAPI(`api/orggroups/orgs/${siteId}/${orgId}`, "DELETE");
}

// update Organization.
export async function updateOrganization(updateJSON) {
  return await connectToAPI(`api/orggroups/orgs`, "PUT", updateJSON);
}

// Get all organizations pools.
export async function getOrganizationsPoolsData(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/orggroups/pools/${siteId}`, undefined, undefined, false, false, finalTabId);
}

// Get specific organization pool Information.
export async function getOrgSpecifcPoolsData(siteId, poolId) {
  return await connectToAPI(`api/orggroups/pools/${siteId}/${poolId}`);
}

// Delete Organization.
export async function deletePool(siteId, poolId) {
  return await connectToAPI(`api/orggroups/pools/${siteId}/${poolId}`, "DELETE");
}

// Add Organization Pool.
export async function addPool(siteId, poolName, orgId) {
  return await connectToAPI(`api/orggroups/pools`, "POST", { pool_name: poolName, siteid: siteId, reqid: 109, orgid: parseInt(orgId) });
}

// update Pool
export async function updateOrgPool(updateJSON) {
  return await connectToAPI(`api/orggroups/pools`, "PUT", updateJSON);
}

// Freshdesk 

export async function getFreshDeskAPIProfiles(siteId) {
  return await connectToAPI(`api/freshdesk/${siteId}`);
}

export async function getSpecificFreshDeskProfile(siteId, profileId) {
  return await connectToAPI(`api/freshdesk/${siteId}/${profileId}`);
}

export async function deleteFreshdeskProfile(stieId, profileId) {
  return await connectToAPI(`api/freshdesk/${stieId}/${profileId}`, "DELETE");
}

export async function createFreshdeskProfile(updates) {
  return await connectToAPI(`api/freshdesk`, "POST", updates);
}

export async function UpdateFreshdeskProfile(updates) {
  return await connectToAPI(`api/freshdesk`, "PUT", updates);
}

export async function getFreshDeskAPITicketLogs(siteId) {
  return await connectToAPI(`api/freshdesk/apiticketlogs/${siteId}`);
}

export async function getFreshDeskAPITicketLogsForPeriodOfTime(siteId, fromDate, toDate) {
  return await connectToAPI(`api/freshdesk/apiticketlogs/${siteId}/${fromDate}/${toDate}`);
}

export async function getDownloadedTicketLogs(siteId) {
  return await connectToAPI(`api/freshdesk/downloadcsvfile/${siteId}`);
}

export async function getDownloadedTicketLogsForPeriodOfTime(siteId, fromDate, toDate) {
  return await connectToAPI(`api/freshdesk/downloadcsvfile/${siteId}/${fromDate}/${toDate}`);
}

export async function createVMBox(updates) {
  return await connectToAPI(`api/call_flows/vmbox`, "POST", updates);
}

export async function getAssociatedCFData(siteId, entityId, nodeType) {
  return await connectToAPI(`api/call_flows/${siteId}/${entityId}/${nodeType}`);
}
export async function getRegisteredLocationsInfo(siteId) {
  return await connectToAPI(`api/phoneProvisiong/${siteId}/getRegisteredLocationsInfo`, "GET");
}

export async function getAccInfo(siteid) {
  return await connectToAPI(`api/global/accpin/${siteid}`);
}

export async function UpdateAccPinCID(updates) {
  return await connectToAPI(`api/global`, "PUT", updates);
}

export async function deleteMsTenant(updates) {
  return await connectToAPI(`api/global/deletemsteamtenant`, "DELETE", updates);
}

export async function getGlobalAccSettingsInfo(siteid, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/global/globalsettings/${siteid}`, undefined, undefined, false, false, finalTabId);
}

// Billing Groups

export async function getAllBillingGroups(siteId, uniquekey, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  if (uniquekey) {
    return await connectToAPI(`api/billing/billinggroups/${siteId}?uniqueKey=${uniquekey}`, undefined, undefined, false, false, finalTabId);
  } else {
    return await connectToAPI(`api/billing/billinggroups/${siteId}`, undefined, undefined, false, false, finalTabId);
  }
}

export async function getSpecificBillingGroups(siteId, code) {
  return await connectToAPI(`api/billing/billinggroups/${siteId}/${code}`);
}

export async function deleteBillingGroups(stieId, grpCode) {
  return await connectToAPI(`api/billing/billinggroups/${stieId}/${grpCode}`, "DELETE");
}

export async function getLTDReportURL(siteId) {
  return await connectToAPI(`api/login/logintoltdreports/${siteId}`);
}

export async function updateBillingGroups(updates, confirm) {
  if(confirm !== undefined)return await connectToAPI(`api/billing/billinggroups?confirm=${confirm}`, "PUT", updates);
  return await connectToAPI(`api/billing/billinggroups`, "PUT", updates);
}

export async function deleteBillingInfo(updates) {
  return await connectToAPI(`api/billing/billinggroups/delete`, "POST", updates);
}

export async function displayCancelAccount(updates) {
  return await connectToAPI(`api/billing/accountinfo/cancelacc`, "POST", updates);
}

export async function updateBillingAccInfo(updates) {
  return await connectToAPI(`api/billing/accountinfo/update`, "POST", updates);
}

export async function getSpecificHardwareRentalProducts(siteId, code) {
  return await connectToAPI(`api/billing/billinggroups/billingquotes/${siteId}/${code}`);
}

export async function getSpecificBIllingUser(siteId, code) {
  return await connectToAPI(`api/billing/billinggroups/users/${siteId}/${code}`)
}
export async function getCreditCardUrl(siteId, billingid) {
  return await connectToAPI(`api/billing/updatecreditcardreq/${siteId}/${billingid}`)
}

export async function getSpecificBIllingGroupGroups(siteId, code) {
  return await connectToAPI(`api/billing/billinggroups/groups/${siteId}/${code}`)
}

export async function updateBillingUsers(updates) {
  return await connectToAPI(`api/billing/billinggroups/users`, "PUT", updates);
}

export async function getBiilingAccountInfoDetails(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/billing/accountinfo/${siteId}`, undefined, undefined, false, false, finalTabId);
}
export async function getBillingQuoteInfo(siteId, quoteid) {
  return await connectToAPI(`api/billing/accountinfo/quoteid/${siteId}/${quoteid}`);
}
export async function getUsageSummaryData(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/billing/usagesummary/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function AddNewBillingGroup(updates) {
  return await connectToAPI(`api/billing/billinggroups`, "POST", updates);
}

export async function addRemoveBillingGroups(updates, isconfirm) {
  if (isconfirm) {
    const confirmValue = isconfirm === 1 ? 0 : 1;
    return await connectToAPI(`api/billing/billinggroups/groups?confirm=${confirmValue}`, "PUT", updates);
  }
  return await connectToAPI(`api/billing/billinggroups/groups`, "PUT", updates);
}

export async function getAllInvoicesStatements(siteId, groupid) {
  return await connectToAPI(`api/billing/billinggroups/invoicesorstmts/${siteId}/${groupid}`);
}

export async function handleDownloadInvoice(siteid, groupid, fileKey) {
  return await connectToAPI(`api/billing/download/billingInvoicesStmts/${siteid}/${groupid}/${fileKey}`);
}

export async function handleViewInvoice(siteid, groupid, fileKey) {
  return await connectToAPI(`api/billing/view/billingInvoicesStmts/${siteid}/${groupid}/${fileKey}`);
}



// Security Manager
export async function getAllSecurityDesktopInfo(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/desktop/${siteId}`, undefined, undefined, false, false, finalTabId);
}
export async function addIPAddr(updates) {
  return await connectToAPI(`api/desktop`, "POST", updates);
}

export async function deleteIPAddr(stieId, ipadd, range) {
  return await connectToAPI(`api/desktop/ipaddress/${ipadd}/${stieId}/${range}`, "DELETE");
}

export async function deleteAuthUser(stieId, id) {
  return await connectToAPI(`api/desktop/authorized/${stieId}/${id}`, "DELETE");
}

export async function deleteBlockedUser(stieId, id) {
  return await connectToAPI(`api/desktop/blocked/${stieId}/${id}`, "DELETE");
}

export async function registerBlockRequest(updates) {
  return await connectToAPI(`api/desktop`, "PUT", updates);
}

export async function trustAccUsers(updates) {
  return await connectToAPI(`api/desktop/trusted`, "PUT", updates);
}

export async function deleteTrustedUser(stieId, id) {
  return await connectToAPI(`api/desktop/trusted/${stieId}/${id}`, "DELETE");
}
export async function sendZTPrequest(siteId, jsonObj) {
  return await connectToAPI(`api/phoneProvisiong/${siteId}/sendZTPrequest`, "POST", jsonObj);
}


//Users Import Export 

export async function exportUsersInfo(siteid) {
  return await connectToAPI(`api/importexport/downloadfile/${siteid}`);
}

export async function uploadUsersInfo(updates) {
  return await connectToAPI(`api/importexport/uploadsheet`, "POST", updates, false, "multipart/form-data");
}

export async function checkUploadStatus(siteid, isAccount) {
  if(isAccount) return await connectToAPI(`api/importexport/status/${siteid}?isaccount=true`);
  return await connectToAPI(`api/importexport/status/${siteid}`);
}
export async function fetchImpExpMiscDetails(siteid) {
  return await connectToAPI(`api/importexport/dropdowns/${siteid}`);
}

export async function impExpReValidate(update) {
  return await connectToAPI(`api/importexport/validate`, "PUT", update);
}

export async function impExpSkip(siteid) {
  return await connectToAPI(`api/importexport/skip/${siteid}`);
}

export async function impExpCancel(siteid) {
  return await connectToAPI(`api/importexport/cancel/${siteid}`);
}
export async function impExpSave(siteid) {
  return await connectToAPI(`api/importexport/save/${siteid}`);
}

// Luna PRD Changes
export async function getLunaProfileList(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/luna/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function deleteLunaProfile(stieId, lunaId) {
  return await connectToAPI(`api/luna/${stieId}/${lunaId}`, "DELETE");
}

export async function createLunaProfile(updates) {
  return await connectToAPI(`api/luna`, "POST", updates);
}

export async function getSpecificLunaDetails(siteid, lunaid) {
  return await connectToAPI(`api/luna/${siteid}/${lunaid}`);
}

export async function updateLunaDetails(updates) {
  return await connectToAPI(`api/luna`, "PUT", updates, false, "multipart/form-data");
}
export async function updateLunaSettings(updates) {
  return await connectToAPI(`api/luna/general`, "PUT", updates);
}

export async function getSpecificLunaScheduleDetails(siteid, lunaid, scheduleid) {
  return await connectToAPI(`api/luna/${siteid}/${lunaid}/${scheduleid}`);
}
export async function getLunaGreetingInfo(greetInfo) {
  return await connectToAPI(`api/luna/greet`, "POST", greetInfo);
}

export async function getSummaryInformation(siteid, lunaid, scheduleid) {
  return await connectToAPI(`api/luna/summary/${siteid}/${lunaid}/${scheduleid}`);
}

export async function downloadLunaPDF(siteid, lunaid, scheduleid, pdfid) {
  return await connectToAPI(`api/luna/${siteid}/${lunaid}/${scheduleid}/${pdfid}`);
}



//Directory
export async function getDirectoryAll(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/directory/${siteId}`, undefined, undefined, false, false, finalTabId);
}

export async function deleteDirectory(siteId, directoryid, validateFlag) {
  return await connectToAPI(`api/directory/${siteId}/${directoryid}${validateFlag ? "?validate_delete_dir=true" : ""}`, "DELETE");
}

export async function addNewDirectory(updates) {
  return await connectToAPI(`api/directory`, "POST", updates);
}

export async function getSpecificDirectory(siteId, dirid) {
  return await connectToAPI(`api/directory/${siteId}/${dirid}`);
}

export async function getDirectoryAllUsers(siteId, dirid) {
  return await connectToAPI(`api/directory/${siteId}/${dirid}/users`);
}


export async function updateDirectory(updates) {
  return await connectToAPI(`api/directory`, "PUT", updates);
}
export async function sendSyncRequest(jsonObj) {
  return await connectToAPI(`api/phoneProvisiong/sendSyncRequest`, "POST", jsonObj);
}



export async function getPagingDetails(siteID, pagingId) {
  return await connectToAPI(
    `api/phoneProvisiong/${siteID}/${pagingId}/getPagingDetails`,
    "GET"
  );
}

export async function getUserGlobalNotifications(siteId, agentId) {
  return await connectToAPI(`api/phoneProvisiong/${siteId}/${agentId}`)
}

export async function createLunaSchedule(updates, siteid, lunaid) {
  return await connectToAPI(`api/luna/schedules/${siteid}/${lunaid}`, "POST", updates);
}

export async function getChatbotData(params) {
  return await connectToAPI(`api/chatbot/`, "POST", params);
}
export async function saveSSOInfo(jsonObj) {
  return await connectToAPI(`api/entraid/sso-info`, "POST", jsonObj);
}

export const TENANT_URL = `${api_serverUrl}api/entra/scim/v2`;
export async function getSSOInfo(siteid, tabId) {
  return await connectToAPI(`api/entraid/sso-info/${siteid}`, "GET", undefined, false, false, tabId);
}
export async function deleteSSOInfo(id) {
  const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
  return await connectToAPI(`api/entraid/sso-info/${id}`, "DELETE", { siteid });
}
// export async function sendEntaidRequest(payload) {
//   return await connectToAPI(`api/entraid/sendEntaidRequest`, "POST", payload);
// }
export async function saveUProvInfo(jsonObj) {
  return await connectToAPI(`api/entraid/prov-info`, "POST", jsonObj);
}
export async function deleteUProvInfo(siteid) {
  return await connectToAPI(`api/entraid/prov-info/${siteid}`, "DELETE");
}
export async function getUProvInfo(siteid, tabId) {
  return await connectToAPI(`api/entraid/prov-info/${siteid}`, "GET", undefined, false, false, tabId);
}
export async function getFailurReport(object) {
  return await connectToAPI(`api/entraid/prov-report-info`, "POST", object);
}

export async function getServicePlans(object) {
  return await connectToAPI(`api/entraid/prov-report-info`, "GET", object);
}
export async function getTermTypes(object) {
  return await connectToAPI(`api/entraid/prov-report-info`, "GET", object);
}
export async function getSInfo(siteid) {
  return await connectToAPI(`api/entraid/prov-serviceinfo-download/${siteid}`);
}

export async function getMSTeamSettingsInfo(siteid) {
  return await connectToAPI(`api/msintegrations/msteams/${siteid}`);
}

export async function updateMSTeamsSettings(updates) {
  return await connectToAPI(`api/msintegrations/msteams`, "PUT", updates);
}

export async function deleteMsTeamFields(siteid) {
  return await connectToAPI(`api/msintegrations/msteams/deletemsteamtenant/${siteid}`, "DELETE");
}
// export async function getNProvisionedUsers(jsonObj) {
//   return await connectToAPI(`api/entraid/prov-report-info/pnusers`, "POST", jsonObj);
// }
// export async function saveUserProvisionPlan(object) {
//   return await connectToAPI(`api/entraid/prov-report-info/pusers`, "POST", object);
// }
// export async function getManualProvisionedUsers(jsonObj) {
//   return await connectToAPI(`api/entraid/manual-prov-users`, "POST", jsonObj);
// }
// export async function updateNProvisionedUsers(update) {
//   return await connectToAPI(`/api/entraid/prov-report-info/pupdateusers`, "PUT", update);
// }

// export async function updateEntraUProvToken(token) {
//   return await connectToAPI(`/api/entraid/prov-info/${token}`, "PUT");
// }

export async function fetchFailureUsers() {
  return await connectToAPI(`api/entraid/prov-report-info`, "GET");
}


export async function saveAskLunaView(jsonObj) {
  return await connectToAPI(`api/global/asklunaview`, "POST", jsonObj);
}
export async function getAskLunaView(siteid, tabId) {
  if(tabId){
    tabId = getTabIdFromSession(tabId);
  }
  return await connectToAPI(`api/global/asklunaview/${siteid}`, "GET", undefined, false, false, tabId);
}

export async function getWSContactsRedirectHtml(contactType, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/contacts/importglobalcontacts${contactType === 1 ? "?contacttype=1" : ""}`, "GET", undefined, false, false, finalTabId);
}



export async function getSpecificDectDevice(siteId, updates) {
  return await connectToAPI(`api/phoneProvisiong/${siteId}/getSpecificDectDevice`,"POST", updates);
}

export async function saveAutoDectDeviceSettings(siteId, params) {
  return await connectToAPI( `api/phoneProvisiong/${siteId}/updateautoDectSettings`,"POST", params);
}

export async function saveDectDeviceButtonsData(siteId, params) {
  return await connectToAPI( `api/phoneProvisiong/${siteId}/saveDectDeviceButtonsData`,"POST", params);
}
//Streams-api-apps Implimentation

export async function getAccountStreamApiAppsInfo(siteId, tabId) {
  const finalTabId = getTabIdFromSession(tabId);
  return await connectToAPI(`api/streams-api-apps/${siteId}/apps`, "GET", undefined, false, false, finalTabId);
}
export async function getAppDetails(siteId,appId) {
  return await connectToAPI(`api/streams-api-apps/${siteId}/apps/${appId}`,"GET");
}

export async function deleteStreamApiApp(siteId, appId,params) {
  return await connectToAPI(`api/streams-api-apps/${siteId}/apps/${appId}`, "DELETE",params);
}
export async function regenerateClientSecretInfo(siteId,appId, params) {
  return await connectToAPI(`api/streams-api-apps/${siteId}/apps/${appId}/regenerate-secret`,"POST",params);
}
export async function AddStreamApiApp(siteId, params) {
  return await connectToAPI(`api/streams-api-apps/${siteId}/apps`,"POST",params);
}
export async function updateStreamApiApp(siteId,appid,params) {
  return await connectToAPI(`api/streams-api-apps/${siteId}/apps/${appid}`,"PUT",params);
}

export async function checkAppNameAvailabilityInfo(siteId,params) {
  return await connectToAPI(`api/streams-api-apps/${siteId}/apps/name-availability`,"POST",params)
}
export async function getDefualtCallBackURLSInfo(siteId) {
  return await connectToAPI(`api/streams-api-apps/${siteId}/apps/callback-urls`);
}
export async function getGoogleContactsRedirectHtml() {
  return await connectToAPI(`api/contacts/importgooglecontacts`, "GET");
}

// Shared Voicemail

export async function getAllSharedVoicemail(siteid) {
  return await connectToAPI(`api/vmbox/${siteid}`);
}

export async function getSpecificSharedVoicemail(siteid, id) {
  return await connectToAPI(`api/vmbox/settings/${siteid}/${id}`);
}

export async function deleteSharedVM(siteid, id) {
  return await connectToAPI(`api/vmbox/${siteid}/${id}`, "DELETE");
}

export async function getVMBoxUsers(siteid, vmid) {
  return await connectToAPI(`api/vmbox/users/${siteid}/${vmid}`);
}

export async function updateSharedVoicemail(params) {
  return await connectToAPI(`api/vmbox/`, "PUT", params);
}

export async function getAccountSummarys(allLocation, siteid, misc, range) {
  const rangeParam = range ? `&range=${range}` : "";
  if(allLocation)return await connectToHeatMapAPI(`heatmap/summary?allaccounts=true${rangeParam}`);
  if(siteid)return await connectToHeatMapAPI(`heatmap/summary?siteids=${siteid}${rangeParam}`);
  if(misc)return await connectToHeatMapAPI(`heatmap/summary?misc=true`);
  return await connectToHeatMapAPI(`heatmap/summary`);
}
export async function getDefualtStreamsApiPermissions() {
  return await connectToAPI(`api/streams-api-apps/apps/app_permissions`);
}

export async function validateForHeatMap(authkey) {


  try {
    const response = await fetch(SERVER_URL + `heatmap/validate`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: authkey
      }
    });
    console.log("Checking validateForHeatMap API authkey response");
    console.log(response);

    return response;
  } catch (error) {
    console.error("Unable to validate Heat map authkey : " + error);
    return { satus: 500 };
  }
}


export async function sendRequestTnReserve(updates) {
  return await connectToAPI(`api/phnum/tnReserve`, "POST", updates);
}


export async function sendRequestTnRelase(updates) {
  return await connectToAPI(`api/phnum/tnRelease`, "POST", updates);
}



export const getAllStreamsLogins = (siteid) =>
  connectToAPI(`api/streamslogins/getall/${siteid}`, "GET");

export const getSpecificStreamsLogins = (siteid, agentid) =>
  connectToAPI(`api/streamslogins/getspecific/${siteid}/${encodeURIComponent(agentid)}`, "GET");

export const forceLogoutStreams = (agentid, tempkeys, islogoffall = 0, siteid) =>
  connectToAPI("api/streamslogins/forcelogout", "POST", { reqid: 177, agentid, tempkeys, islogoffall, siteid });


// phone number location multi save
export async function getPhoneMultiSaveOptions(updates) {
  return await connectToAPI(`api/phnum/multisave/`, "POST", updates);
}

export async function savePhoneMultiSave(updates, confirmFlag) {
  const confirmQuery = confirmFlag ? "?is_confirm=true" : "";
  return await connectToAPI(`api/phnum/multisave/${confirmQuery}`, "PUT", updates);
}